import { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { cn } from '@bem-react/classname'

import { Field } from '@/components/Form/Field'
import Icon from '@/components/UI/Icon'
import { Tag } from '@/components/UI/Tag'

import { RegisterEmailModel } from '../../models/Register.model'
import './EmailStep.scss'

interface IEmailStepProps {
  className?: string
}

const cnEmailStep = cn('EmailStep')

export const EmailStep: FC<IEmailStepProps> = ({ className }) => {
  const { t } = useTranslation()

  const {
    register,
    formState: { errors },
  } = useFormContext<RegisterEmailModel>()

  return (
    <div className={cnEmailStep(null, [className])}>
      <Tag className={cnEmailStep('title')}>{t('register-first-title')}</Tag>
      <div className={cnEmailStep('text')}>{t('register-first-text')}</div>
      <Field
        iconLeft={
          <Icon
            name='email'
            stroke={
              errors.email?.message ? 'var(--badges-alerts-red)' : 'white'
            }
          />
        }
        placeholder={t('register-placeholder-email')}
        label={t('register-label-email')}
        mb='none'
        {...register('email')}
        errors={errors.email?.message}
        required
      />
    </div>
  )
}
